import { memo } from "react";
import { PRODUCTS } from "../products";
import * as styles from "./landing-skeleton.module.css";

export const LandingSkeleton = memo(function LandingSkeleton() {
  return (
    <>
      <header className={styles.header}>
        <div className={styles.navBar}>
          <div className={styles.brandGroup}>
            <div className={`${styles.avatarBone} ${styles.bone}`} />
            <div className={`${styles.nameBone} ${styles.bone}`} />
          </div>
          <div className={styles.rightGroup}>
            <div className={`${styles.iconTagBone} ${styles.bone}`} />
            <div className={`${styles.tagBone} ${styles.bone}`} />
          </div>
        </div>
        <div className={styles.divider} />
      </header>

      <div className={styles.body}>
        <div className={styles.leftColumn}>
          <div className={styles.leftInner}>
            <div className={`${styles.titleBone} ${styles.bone}`} />
            <div className={`${styles.descBone} ${styles.bone}`} />
          </div>
        </div>

        <div className={styles.rightColumn}>
          <div className={styles.grid}>
            {Array.from({ length: PRODUCTS.length }, (_, i) => (
              <div className={`${styles.cardBone} ${styles.bone}`} key={i} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
});
